import React from "react";
import { useSelector } from "react-redux";

const useMigrateToNewUi = () => {
  const auth = useSelector((state) => state.auth);
  // `hotel` lets callers without a selected hotel (group pages) hand over a
  // specific property; callers that omit it keep the previous behaviour
  const prepareNewUiData = (hotel) => {
    const params = new URLSearchParams(window.location.search);
    const targetHotel = hotel || auth.selectedHotel;
    let token = localStorage.getItem("token") || "";
    if (token.includes("||master")) {
      token = token.replace(/(\|\|master)+$/, "");
    }
    const data = {
      authToken: token,
      authUser: { email: auth.email },
      currentUser: { email: auth.email, userType: "hotel_user" },
      groupHotelDetails: [],
      groupId: localStorage.getItem("mainGroupId"),
      hotelDetail: {
        hotelName: targetHotel?.hotelName,
        hotelCurrency: targetHotel?.hotelCurrency,
      },
      hotelEmail: localStorage.getItem("HotelEmail"),
      hotelId: params.get("hotelId") || targetHotel?.hotelId,
    };
    if (localStorage.getItem("rootEmail")) {
      data["masterUser"] = {
        email: localStorage.getItem("rootEmail"),
      };
    }
    return data;
  };

  const directToNewUi = (hotel) => {
    // required: authToken, authUser, currentUser, groupHotelDetails, groupId, hotelDetail, hotelEmail, hotelId
    const data = prepareNewUiData(hotel);
    const url = "https://pms.stayflexi.com/property-dashboard/";
    const encodedData = JSON.stringify(data);
    const href = `${url}?data=${encodedData}`;
    window.location.href = href;
  };
  return { directToNewUi };
};

export default useMigrateToNewUi;
